export default __webpack_public_path__ + "static/EnergyLabelLinks2_x2-edb9aafb9581289ba9579f24634afa21.png";